const VestDetail = () => import('@/views/VestDetail')

export default [
  {
    path: '/vestDetail',
    component: VestDetail,
    meta: { requireAuth: true, vest: true }
  }
]
